/****************************************************
 * Module Name:  customerMaster.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Box } from "@mui/material";
import CustomerMasterComponent from "../common/customerMasterComponent";

export class CustomerMaster extends Component {
  render() {
    return (
      <Box>
        <CustomerMasterComponent editButton={true} />
      </Box>
    );
  }
}

export default CustomerMaster;
